class LocalStorageService {
  authTokenKey: string
  tokenType: string

  constructor() {
    this.authTokenKey = 'ENERGY_AUTH'
    this.tokenType = 'Bearer'
  }

  getAuthToken() {
    // return localStorage.getItem(this.authTokenKey)
    return 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2lkIjoic3RyaW5nIiwiZXhwaXJlcyI6NjAxNjYzMDYxMzA2LjIyODR9.YvatiyhWkuX8yaMtQU-79CTqcgLof92T5l-A8fQiFF0'
  }
  setAuthToken(token = '') {
    localStorage.setItem(this.authTokenKey, `${this.tokenType} ${token}`)
  }
  removeAuthToken() {
    localStorage.removeItem(this.authTokenKey)
  }
}

export default new LocalStorageService()
